<form class="drill-form" [formGroup]="form" (ngSubmit)="submit()">
  <sz-section-head [label]="'drills.form.nameLabel' | translate" [count]="null" />
  <sz-text-input
    formControlName="name"
    [placeholder]="'drills.form.namePlaceholder' | translate"
    [maxLength]="nameMax"
    [showCounter]="true" />

  <sz-section-head [label]="'drills.form.typeLabel' | translate" />
  <sz-segmented [options]="typeOptions()" [value]="currentType()" (valueChange)="setType($event)" />

  <sz-section-head [label]="'drills.form.scoringLabel' | translate" />
  <div class="drill-form__scoring-list">
    @for (s of scoringOptions(); track s.key) {
      <sz-radio-card
        [label]="s.label"
        [description]="s.description"
        [selected]="currentScoring() === s.key"
        (select)="setScoring(s.key)" />
    }
  </div>

  @if (isHitFactor()) {
    <sz-section-head [label]="'drills.form.shotsCountLabel' | translate" [count]="null" />
    <button
      type="button"
      class="drill-form__shots-button"
      [class.drill-form__shots-button--empty]="shotsCountValue() === null"
      (click)="openShotsSheet()">
      @if (shotsCountValue(); as v) {
        <span class="drill-form__shots-button-value">{{ v }}</span>
        <span class="drill-form__shots-button-unit">{{ 'drills.form.shotsCountUnit' | translate }}</span>
      } @else {
        <span class="drill-form__shots-button-placeholder">{{ 'drills.form.shotsCountTapToSet' | translate }}</span>
      }
    </button>
  }

  <sz-section-head [label]="'drills.form.descriptionLabel' | translate" [count]="null">
    <span class="drill-form__optional">{{ 'drills.form.optional' | translate }}</span>
  </sz-section-head>
  <sz-textarea
    formControlName="description"
    [placeholder]="'drills.form.descriptionPlaceholder' | translate"
    [rows]="3"
    [maxLength]="descriptionMax"
    [showCounter]="true" />

  <div class="drill-form__favorite">
    <div class="drill-form__favorite-body">
      <div class="drill-form__favorite-label">{{ 'drills.form.favoriteLabel' | translate }}</div>
      <div class="drill-form__favorite-helper">{{ 'drills.form.favoriteHelper' | translate }}</div>
    </div>
    <sz-toggle formControlName="favorite" [ariaLabel]="'drills.form.favoriteLabel' | translate" />
  </div>
</form>

<sz-bottom-sheet [open]="shotsSheetOpen()" (close)="closeShotsSheet()">
  <div szSheetHeader class="drill-form__sheet-head">
    <div class="drill-form__sheet-title">{{ 'drills.form.shotsCountSheetTitle' | translate }}</div>
    <sz-icon-button icon="x" size="sm" [ariaLabel]="'common.close' | translate" (click)="closeShotsSheet()" />
  </div>

  <div class="drill-form__sheet-body">
    <div class="drill-form__sheet-display">
      <sz-num-focal [value]="shotsDraftDisplay()" [unit]="'drills.form.shotsCountUnit' | translate" size="xl" />
    </div>
    <sz-numpad-grid [keys]="numpadKeys()" (press)="onShotsKeyPress($event)" />
    <div class="drill-form__sheet-footer">
      <sz-button variant="secondary" size="sm" (click)="closeShotsSheet()">
        {{ 'common.cancel' | translate }}
      </sz-button>
      <sz-button variant="primary" [disabled]="!canSaveShots()" (click)="saveShots()">
        <sz-icon name="check" [size]="16" />
        {{ 'common.save' | translate }}
      </sz-button>
    </div>
  </div>
</sz-bottom-sheet>
